import Button from '@components/ui/ButtonV2/Button'
import {
  selectCountries,
  selectCountry,
  selectLabels,
} from '@redux/globalSlice'
import { openModalView } from '@redux/modalSlice'

import clsx from 'clsx'
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import { match } from 'path-to-regexp'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import s from './MarketMatchingModal.module.scss'

type MarketMatchingModalProps = {
  isOpen: boolean
  setIsOpen?: (value: boolean) => void
}
const MarketMatchingModal: FC<MarketMatchingModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const router = useRouter()
  const countries = useSelector(selectCountries)
  const country = useSelector(selectCountry)

  const dispatch = useDispatch()
  const labels = useSelector(selectLabels)
  const pathPattern = '/:lang/:country/:path*'
  const matchFn = match(pathPattern, { decode: decodeURIComponent })
  const pathWithoutQuery = router.asPath.split('?')[0]
  const relativePath = matchFn(pathWithoutQuery)
  const queryParamsString = router.asPath.split('?')[1] || ''
  const queryParams = new URLSearchParams(queryParamsString)

  const homeCountry =
    countries.find(
      (c) => c.code.toLowerCase() == Cookies.get('homeCountry')?.toLowerCase(),
    ) ?? countries.find((c) => c.code.toLowerCase() == 'int')

  const handleCloseModal = () => {
    sessionStorage.setItem('hideMarketMatchingModal', 'true')
    setIsOpen && setIsOpen(false)
  }

  return (
    <div className={clsx(s.root, { [s.open]: isOpen })}>
      <div className={s.modal}>
        <div className="flex flex-col">
          <div className="bodyText max-w-md mb-5">
            <b>
              {labels.labelCountrySuggestionHeadline.replace(
                '{country}',
                homeCountry.name,
              )}
            </b>
            <br />
            {labels.labelCountrySuggestionBody}
          </div>

          <div className="flex items-center gap-4">
            <div className="w-1/2">
              <Button
                onClick={handleCloseModal}
                variant="primary"
                size="small"
                className="w-full !justify-start whitespace-nowrap"
                labelClassName="flex items-center gap-2"
              >
                <img
                  style={{ width: '18px', aspectRatio: 1 }}
                  src={`https://media.gubi.com/countries/${country?.code.toUpperCase()}.svg`}
                  alt={country?.name}
                />
                <div className="overflow-hidden text-ellipsis">
                  {country?.name}
                </div>
              </Button>
            </div>

            <a
              className="w-1/2"
              onClick={handleCloseModal}
              // query={{
              //   ...router.query,
              //   pages: router.query?.pages?.includes('home')
              //     ? undefined
              //     : router.query?.pages,
              //   country: homeCountry.alpha2Code.toLowerCase(),
              // }}
              href={`/en/${homeCountry.code.toLowerCase()}${
                relativePath
                  ? (relativePath.params as any)?.path?.join('/')
                    ? `/${(relativePath.params as any)?.path?.join('/')}`
                    : ''
                  : ''
              }${queryParams.toString() ? `?${queryParams.toString()}` : ''}`}
            >
              <Button
                variant="secondary"
                size="small"
                className="w-full !justify-start whitespace-nowrap"
                labelClassName="flex items-center gap-2"
              >
                <img
                  style={{ width: '18px', aspectRatio: 1 }}
                  src={`https://media.gubi.com/countries/${homeCountry?.code.toUpperCase()}.svg`}
                  alt={homeCountry.code}
                />
                <div className="overflow-hidden text-ellipsis">
                  {homeCountry.name}
                </div>
              </Button>
            </a>
          </div>

          <Button
            as={'a'}
            size="no-padding"
            variant="underline"
            onClick={() => dispatch(openModalView('MARKET_SELECTION'))}
            className={'!mt-5 w-fit'}
          >
            {labels.labelAllCountriesBtn}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default MarketMatchingModal
